module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/Daoan/downarrow.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FDaoan%2Fdownarrow.png
// module id = l4g7
// module chunks = 93